<template>
  <div class="color-question-view">
    <!-- <div class="question-desc-view">{{questioninfo.desc}}</div> -->
    <div class="color-question-info-view">
      <el-row class="color-content-row" type="flex">
        <el-col :span="6">
          <div class="color-left-content" v-if="questioninfo.content_audio">
            <div class="play-content-bg">
              <div :class="colorplay?'color-playing':''"></div>
              <div class="color-play-btn" @click="playcolor"></div>
            </div>
          </div>
          <div class="color-left-content1" v-else>
            <div class="color-icon-view"></div>
            <div class="color-contenttext-view" v-html="questioninfo.content"></div>
          </div>
        </el-col>
        <el-col class="color-content-view" :span="12">
          <canvas id="colorCanvas" @click="tofillstyle" crossOrigin="anonymous"></canvas>
        </el-col>
        <el-col class="color-right-content" :span="6" v-if="!showanswertype">
          <div class="color-right-options-view">
            <template v-for="item in colors">
              <div class="color-option-item" :style="'background:'+item" @click="choseColor(item)"></div>
            </template>
          </div>
          <div class="chose-color-view">
            <div class="chose-color-item" v-if="colorChose" :style="'background:'+colorChose"></div>
          </div>
          <div class="chose-pen-view" :style="'background:'+colorChose">
            <div class="color-pen-view" :class="colorChose!=''?'color-pen-view1':''"></div>
          </div>
        </el-col>

      </el-row>
    </div>
    <audio ref="colormusic" controls="controls" style="display: none"
           preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>

  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils";
  import Apis from "@/api"

  export default {
    name: "colorquestion",
    data() {
      return {
        colors: ["#FF0000", "#FF8E35", "#FFE94A", "#71D14E", "#538ED8", "#822AF5", "#FFABBA", "#863A39", "#A8A8AA", "#FFFFFF", "#000001"],
        names: ["red", "orang", "yellow", "green", "bule", "purple", "pink", "brown", "grey", "white", "black"],
        questioninfo: {},
        oldColor: "#ffffff",
        colorChose: "",
        baseUrl: apiUtil.getBaseUrl(),
        showanswertype: false,
        isCanClick: false,
        showanswerdialog: false,
        audiourl: "",
        nameindex: 0,
        showdesc: true,
        localindex: 0,
        totalindex: 0,
        descplay: false,
        colorplay: false
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })

    },
    methods: {
      showdescbtn() {
        if (this.showdesc == false) {
          this.showdesc = true;
          this.$refs.colormusic.pause()
        }
      },
      initData() {
        this.questioninfo = this.paraseData();
        this.showimg();
      },
      paraseData() {
        if (typeof this.questionData.content_img != "object") {
          var content_img = this.questionData.content_img.replace(/<img>/g, "").split("|")
          this.questionData.content_img = content_img
        }
        return this.questionData;
      },
      tofillstyle() {
        if (this.colorChose != "") {
          this.isCanClick = true;
          var ctx = this.ctx
          var that = this
          var imgdata = ctx.getImageData(0, 0, 400, 400)
          that.imgDatas = imgdata
          var imgdata = this.imgDatas
          var lastimgdata = this.replaceColor(imgdata, 0, 0, 400, 400)
          ctx.putImageData(lastimgdata, 0, 0)
          this.checkanswer()
        }
      },
      replaceColor(imageData, x, y, w, h) {
        var sourceColor = this.colorRgb(this.oldColor)
        var replaceColor = this.colorRgb(this.colorChose)
        var x = x || 0,
          y = y || 0,
          w = x + w || imageData.width,
          h = y + h || imageData.height;
        if (x < 0 || y < 0 || w > imageData.width || h > imageData.height) {
          throw new Error("error params!");
        }
        for (var j = y; j < h; j++) {
          for (var i = x; i < w; i++) {
            var index = j * imageData.width + i,
              r = imageData.data[4 * index],
              g = imageData.data[4 * index + 1],
              b = imageData.data[4 * index + 2];
            if (r == sourceColor[0] && g == sourceColor[1] && b == sourceColor[2]) {
              if (replaceColor) {
                imageData.data[4 * index] = replaceColor[0];
                imageData.data[4 * index + 1] = replaceColor[1];
                imageData.data[4 * index + 2] = replaceColor[2];
                imageData.data[4 * index + 3] = 255;
              } else {
                imageData.data[4 * index + 3] = 0;
              }
            }
          }
        }
        this.oldColor = this.colorChose
        return imageData;
      },
      colorRgb(str) {
        var sColor = str.toLowerCase();
        //十六进制颜色值的正则表达式
        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        // 如果是16进制颜色
        if (sColor && reg.test(sColor)) {
          if (sColor.length === 4) {
            var sColorNew = "#";
            for (var i = 1; i < 4; i += 1) {
              sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
            }
            sColor = sColorNew;
          }
          //处理六位的颜色值
          var sColorChange = [];
          for (var i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
          }
          return sColorChange;
        }
        return sColor;
      },
      showimg() {
        let that = this;
        setTimeout(function () {
            var width = document.body.clientWidth;
            var c = document.getElementById("colorCanvas");
            if (width > 1600) {
              c.width = 400;
              c.height = 400;
              var ctx = c.getContext("2d");
              ctx.clearRect(0, 0, c.width, c.height);
              ctx.allowTaint = false
              var img = new Image();
              img.src = that.baseUrl + that.questioninfo.content_img[0];
              img.crossOrigin = 'anonymous';
              img.setAttribute('crossOrigin', 'anonymous');
              img.onload = function () {
                ctx.drawImage(img, 0, 0, c.width, c.height);
                that.ctx = ctx;
              }
            } else if (width > 1300) {
              var c = document.getElementById("colorCanvas");
              c.width = 230;
              c.height = 230;
              var ctx = c.getContext("2d");
              ctx.allowTaint = false
              ctx.clearRect(0, 0, c.width, c.height);
              var img = new Image();
              img.src = that.baseUrl + that.questioninfo.content_img[0];
              img.crossOrigin = 'anonymous';
              img.setAttribute('crossOrigin', 'anonymous');
              img.onload = function () {
                ctx.drawImage(img, 0, 0, c.width, c.height);
                that.ctx = ctx;
              }
            } else {
              var c = document.getElementById("colorCanvas");
              c.width = 300;
              c.height = 300;
              var ctx = c.getContext("2d");
              ctx.clearRect(0, 0, c.width, c.height);
              ctx.allowTaint = false
              var img = new Image();
              img.src = that.baseUrl + that.questioninfo.content_img[0];
              img.crossOrigin = 'anonymous';
              img.setAttribute('crossOrigin', 'anonymous');
              img.onload = function () {
                ctx.drawImage(img, 0, 0, c.width, c.height);
                that.ctx = ctx;
              }
            }
          }, 100)
        setTimeout(()=>{
          that.$nextTick(()=>{
            if(that.questioninfo.useroption){
              that.colorChose=that.questioninfo.useroption
              that.tofillstyle()
            }
          })
        },500)
      },
      choseColor(color) {
        this.colorChose = color
      },
      playcolor() {
        this.audiourl = this.baseUrl + this.questioninfo.content_audio;
        this.$refs.colormusic.src = this.audiourl;
        if (this.$refs.colormusic.paused) {
          this.$refs.colormusic.play()
          this.colorplay = true;
        }
      },

      checkanswer() {
        var usercolor = ""
        if (this.oldColor == "#000001") {
          usercolor = "#000000"
        } else {
          usercolor = this.oldColor;
        }
        this.questioninfo.useroption = this.oldColor
        this.questioninfo.isfinish = true;
        this.$refs.colormusic.pause()
        this.colorplay = false;
        this.$emit("questionfinish", this.questioninfo)
      },
      prev() {
        this.$refs.colormusic.pause()
        this.descplay = false;
        this.colorplay = false;
        this.$emit("goToPrev")
      },
      next() {
        this.$refs.colormusic.pause()
        this.descplay = false;
        this.colorplay = false;
        this.$emit("goToNext")
      },
      playend() {
        this.colorplay = false;
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .color-question-view {
    width 100%;
    height 100%;
  }

  .color-question-info-view {
    display: flex;
    width: 100%;
    height: 70%;
    position: relative;
  }

  @media screen and  (min-width: 2200px) {
    .color-question-info-view {
      background #F6C753;
      display: flex;
      width: 100%;
      height: 70%;
    }
  }

  @media screen and  (max-width: 2010px) {
    .color-question-info-view {
      background #F6C753;
      display: flex;
      width: 100%;
      height: 70%;
      position: relative;
    }
  }

  .color-content-row {
    width 100%;
    height 100%;
    display flex;
    align-self center;
    border-radius 12px;
    background #fff;
    align-items center;
  }

  .color-content-view {
    border 3px solid #131313;
    padding 20px 0;
    border-radius 12px;
  }

  .color-answer-content {
    width 100%;
    height 100%;
    display flex;
    justify-content center;
    align-items center;
  }

  .color-answer-content img {
    width 400px;
    height 400px;
  }

  .color-left-content {
    float right;
  }

  .color-left-content1 {
    width 300px;
    height 456px;
    float right;
    background url("../../assets/img/color-text-bg.png");
    background-size 100% 100%;
  }

  .color-icon-view {
    margin-top 20px;
    margin-left 30px;
    width 30px;
    height 30px;
    background url("../../assets/img/quotation-marks.png");
  }

  .color-contenttext-view {
    margin-top 20px;
    font-size 28px;
    padding 10px;
    text-align left;
  }

  .color-right-content1 {
    height 100%;
    display flex;
    flex-direction column;
    align-items center;
    justify-content center;
    font-size 30px;
  }

  .color-right-content1 img {
    width 350px;
    height 220px;
    margin-bottom 10px;
  }

  .color-right-content {
    height 100%;
    display flex;
    flex-direction column;

    .color-right-options-view {
      margin-right 30px;
      margin-top 30px;
      width 80%;
      display flex;
      float right;
      flex-wrap wrap;
      justify-content flex-end;

      .color-option-item {
        width 36px;
        height 36px;
        margin 10px 18px;
        border-radius 50%;
        border 3px solid #131313;
      }
    }

    .chose-color-view {
      width 80%;
      margin-right 30px;
      display flex;
      float right;
      justify-content flex-end;

      .chose-color-item {
        margin-top 20px;
        margin-right 30px;
        width 90px;
        height 90px;
        border-radius 50%;
        border 3px solid #131313;
      }
    }
  }

  .color-play-btn {
    width 120px;
    height 120px;
    background url("../../assets/img/showanswer-play-btn.png")
    background-size 100% 100%;
    z-index 10;
  }

  .play-content-bg {
    width 160px;
    height 160px;
    margin-right 42px;
    display flex;
    justify-content center;
    align-items center;
    position relative;
  }

  .color-playing {
    width 160px;
    height 160px;
    position absolute;
    left 0;
    top 0;
    background url("../../assets/img/playing-content-bg.png");
    background-size 100% 100%;
    animation: bgplayingrun 2s steps(1, start) infinite;
    -webkit-animation: bgplayingrun 2s steps(1, start) infinite;
  }

  .chose-pen-view {
    width 90px;
    height 112px;
    position absolute;
    bottom 0;
    right 7%;

    .color-pen-view {
      width 100%;
      height 100%;
      background url("../../assets/img/color-pen-bg.png");
    }

    .color-pen-view1 {
      width 100%;
      height 100%;
      background url("../../assets/img/color-pen-bg1.png");
    }
  }

  .color-pic-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;

    .color-pic-finish-btn {
      width 50%;
      height 72px;
      font-size 36px;
      position absolute;
      left 25%;
      bottom 30px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }

    .color-pic-finish-view {
      width 100%;
      height 90px;
      display flex;
      position absolute;
      bottom 0;
    }

    .color-pic-answer-right-bottom-view img {
      margin-right 15px;
    }

    .color-pic-answer-right-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 36px;
      background #92C761;
    }

    .color-pic-finish-wrong {
      width: 100%;
      height 100%;
      display flex;
      justify-content center;
      align-items center;

      .color-pic-answer-wrong-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 36px;
        background #F45578;
      }

      .color-pic-answer-wrong-bottom-view img {
        margin-right 15px;
      }
    }
  }

  .color-pic-show-answer-btn {
    font-size 24px;
    color #fff;
    padding 0 15px;
    display flex;
    height 100%;
    flex-direction column;
    justify-content center;
    align-items center;
    background #92C761;
  }

  .color-pic-show-answer-dialog {
    width 100%;
    height 100%;
    position fixed;
    top 0;
    left 0;
    background #65d67a;
    z-index 2000;
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
  }

  .close-answer-dialog {
    background url("../../assets/img/answer-close-bg.png")
    background-size 100% 100%;
    width 180px;
    height 180px;
    position absolute;
    left -90px;
    top -90px;
    z-index 11;
  }

  .color-pic-show-answer-content-view {
    width 88.5%;
    height 71.1%;
    background #fff;
    border-radius 12px;
    position relative;
    display flex;
    align-items center;
    justify-content center;

    margin auto;
  }

  .canvas-color-pic-question-info-view1 {
    width 96%;
    height 90%;
    box-shadow: 0px 10px 42px 9px rgba(189, 189, 189, 0.36);
    border-radius: 24px;
  }

  .dialog-toast-text {
    margin-top 24px;
    font-size 36px;
    color #131313;
    font-weight bold;
  }

  .answer-icon-view {
    width 90px;
    height 90px;
    border-radius 50%;
    border 6px solid #131313;
    margin-bottom 40px;
  }

  .show-answer-content-info {
    width 50%;
    height 96%;
    margin 1% auto;
    overflow-y auto;
    font-size 36px;
    text-align left;
    line-height 50px;
  }

  @media screen and (max-width: 1600px) {
    .color-question-info-view {
      top -6%;
    }

    .color-pic-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .color-pic-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
        border-radius 36px;
        background #5777FF;
        color #fff;
      }

      .color-pic-finish-view {
        width 100%;
        height 50px;
        display flex;
        position absolute;
        bottom 0;
      }

      .color-pic-answer-right-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .color-pic-answer-right-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #92C761;
      }

      .color-pic-finish-wrong {
        width: 100%;
        height 100%;
        display flex;
        justify-content center;
        align-items center;

        .color-pic-answer-wrong-bottom-view {
          display flex;
          flex 1;
          height 100%;
          justify-content center;
          align-items center;
          color #fff;
          font-size 24px;
          background #F45578;
        }

        .color-pic-answer-wrong-bottom-view img {
          width 40px;
          height 40px;
          margin-right 15px;
        }
      }

      .color-pic-show-answer-btn {
        font-size 18px;
        color #fff;
        padding 0 15px;
        display flex;
        height 100%;
        flex-direction column;
        justify-content center;
        align-items center;
        background #92C761;
      }

      .color-pic-show-answer-btn img {
        width 20px;
        height 20px;
      }
    }

    .color-right-content {
      height 100%;
      display flex;
      flex-direction column;

      .color-right-options-view {
        margin-right 10px;
        margin-top 10px;
        width 80%;
        display flex;
        float right;
        flex-wrap wrap;
        justify-content flex-end;

        .color-option-item {
          width 30px;
          height 30px;
          margin 5px 18px;
          border-radius 50%;
          border 3px solid #131313;
        }
      }

      .chose-color-view {
        width 80%;
        margin-right 20px;
        display flex;
        float right;
        justify-content flex-end;

        .chose-color-item {
          margin-top 10px;
          margin-right 30px;
          width 57px;
          height 57px;
          border-radius 50%;
          border 3px solid #131313;
        }
      }
    }

    .color-right-content1 img {
      width 300px;
      height 180px;
      margin-bottom 10px;
    }

    .color-left-content1 {
      width 280px;
      height 348px;
      float right;
      background url("../../assets/img/color-text-bg.png");
      background-size 100% 100%;
    }
  }

  @media screen and (max-width: 1366px) and (max-height: 657px) {
    .color-question-info-view {
      top -6%;
    }

    .color-pic-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .color-pic-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
        border-radius 36px;
        background #5777FF;
        color #fff;
      }

      .color-pic-finish-view {
        width 100%;
        height 50px;
        display flex;
        position absolute;
        bottom 0;
      }

      .color-pic-answer-right-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .color-pic-answer-right-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #92C761;
      }

      .color-pic-finish-wrong {
        width: 100%;
        height 100%;
        display flex;
        justify-content center;
        align-items center;

        .color-pic-answer-wrong-bottom-view {
          display flex;
          flex 1;
          height 100%;
          justify-content center;
          align-items center;
          color #fff;
          font-size 24px;
          background #F45578;
        }

        .color-pic-answer-wrong-bottom-view img {
          width 40px;
          height 40px;
          margin-right 15px;
        }
      }

      .color-pic-show-answer-btn {
        font-size 18px;
        color #fff;
        padding 0 15px;
        display flex;
        height 100%;
        flex-direction column;
        justify-content center;
        align-items center;
        background #92C761;
      }

      .color-pic-show-answer-btn img {
        width 20px;
        height 20px;
      }
    }

    .color-right-content {
      height 100%;
      display flex;
      flex-direction column;

      .color-right-options-view {
        margin-right 10px;
        margin-top 10px;
        width 80%;
        display flex;
        float right;
        flex-wrap wrap;
        justify-content flex-end;

        .color-option-item {
          width 30px;
          height 30px;
          margin 5px 18px;
          border-radius 50%;
          border 3px solid #131313;
        }
      }

      .chose-color-view {
        width 80%;
        margin-right 20px;
        display flex;
        float right;
        justify-content flex-end;

        .chose-color-item {
          margin-top 10px;
          margin-right 30px;
          width 57px;
          height 57px;
          border-radius 50%;
          border 3px solid #131313;
        }
      }
    }

    .color-right-content1 img {
      width 300px;
      height 180px;
      margin-bottom 10px;
    }

    .color-left-content1 {
      width 280px;
      height 308px;
      float right;
      background url("../../assets/img/color-text-bg.png");
      background-size 100% 100%;
    }

    .play-content-bg {
      width 80px;
      height 80px;
      margin-right 42px;
      display flex;
      justify-content center;
      align-items center;
      position relative;
    }

    .color-play-btn {
      width 80px;
      height 80px;
      background url("../../assets/img/showanswer-play-btn.png")
      background-size 100% 100%;
      z-index 10;
    }
  }

  @keyframes bgplayingrun {

  0% {
    transform: scale(.6);
  }
  10% {
    transform: scale(.7);
  }
  20% {
    transform: scale(.8);
  }
  30% {
    transform: scale(.9);
  }
  40% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  60% {
    transform: scale(1);
  }
  70% {
    transform: scale(.9);
  }
  80% {
    transform: scale(.8);
  }
  90% {
    transform: scale(.7);
  }
  100% {
    transform: scale(.6);
  }
  }

  @-webkit-keyframes bgplayingrun {
    0% {
      transform: scale(.6);
    }
    10% {
      transform: scale(.7);
    }
    20% {
      transform: scale(.8);
    }
    30% {
      transform: scale(.9);
    }
    40% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    60% {
      transform: scale(1);
    }
    70% {
      transform: scale(.9);
    }
    80% {
      transform: scale(.8);
    }
    90% {
      transform: scale(.7);
    }
    100% {
      transform: scale(.6);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/colorquestion.vue